module.exports = (function (){
	require('./src/mtop-2.3.16');

	if (!window.lib || !window.lib.mtop) {
	    console.error('window.lib.mtop undefined!');
	} else {
		var _mtop = {};
		var isPrev = false;
	    if (window.location && window.location.href.indexOf('_mtopPrev_=_true_') != -1) {
	        isPrev = true;
	    }
	    // 默认的参数 但是存在的风险是如果跨部门混用的情况需要在发送请求之前进行设置
	    window.lib.mtop.config.prefix = isPrev ? 'pre-acs' : 'acs'; // mtop的前缀
	    window.lib.mtop.config.subDomain = ''; // mtop的子域
	    window.lib.mtop.config.H5Request = true;
	    window.lib.mtop.config.mainDomain = 'aliexpress.com/'; // mtop的主域

	    _mtop.request = function (arg) {
	        // 设置缺省的APPKey AE PC的key是这个
	        if (arg && !arg.appKey) {
	            arg.appKey = 24815441
	        }
	        return lib.mtop.request(arg);
	    };

	    return _mtop;
	}
})();
